import {Component, EventEmitter, Input, Output, SimpleChanges, ViewChild} from '@angular/core';
import {
  GoogleMap,
  GoogleMapsModule,
  MapInfoWindow,
  MapMarker
} from '@angular/google-maps';
import { LocationModel } from '../../../../models/resources/location.model';

@Component({
  selector: 'app-meeting-points-map',
  imports: [
    GoogleMapsModule,
  GoogleMap,
  MapMarker,],
  templateUrl: './meeting-points-map.component.html',
  styleUrl: './meeting-points-map.component.scss',
})
export class MeetingPointsMapComponent {
  @Input() center: google.maps.LatLngLiteral = { lat: 48.2082, lng: 16.3738 };
  @Input() zoom = 10;
  @Input() points: LocationModel[] = [];

  @Output() mapClicked = new EventEmitter<google.maps.LatLngLiteral>();

  @ViewChild(MapInfoWindow) infoWindow?: MapInfoWindow;

  markerPosition: google.maps.LatLngLiteral = { lat: 48.2082, lng: 16.3738 };
  activePoint: LocationModel | null = null;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['center'] && this.center) {
      this.markerPosition = { ...this.center };
    }
  }

  onMapClick(event: google.maps.MapMouseEvent) {
    if (!event.latLng) return;

    const coords = event.latLng.toJSON();
    this.markerPosition = coords;
    this.mapClicked.emit(coords);
  }

  isValidPoint(p: LocationModel): boolean {
    return Number.isFinite(Number(p.latitude)) &&
      Number.isFinite(Number(p.longitude));
  }

  pointPosition(p: LocationModel): google.maps.LatLngLiteral {
    return {
      lat: Number(p.latitude),
      lng: Number(p.longitude),
    };
  }

  formatAddress(p: LocationModel): string {
    const a = p.address;
    if (!a) return '';
    const street = [a.street, a.houseNumber].filter(Boolean).join(' ');
    const city = [a.postcode, a.place].filter(Boolean).join(' ');
    return [street, city].filter(Boolean).join(', ');
  }

  openInfo(marker: MapMarker, point: LocationModel) {
    this.activePoint = point;
    this.infoWindow?.open(marker);
  }
}
